import React from 'react';
import routes from './routes';
import AppLayout from 'containers/AppLayout';
import { IRoute } from 'data';
import ProductSelector from './components/ProductSelector';

const ProductAppLayout: React.FC = () => {
  return (
    <AppLayout routes={routes as IRoute[]} customHeader={<ProductSelector />} />
  );
};

export default ProductAppLayout;
